import { createSlice } from "@reduxjs/toolkit";
import { yearlyCampaign } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const yearlyCampaignSlice = createSlice({
  name: "yearlyCampaign",
  initialState: data,
  reducers: {
    yearlyCampaignSlice(state) {
      state.isLoading = false;
    },
    yearlyCampaignSliceSuccess(state, action) {
        state.isLoading = true;
        state.data = action.payload;
        state.message = null;
      },
      yearlyCampaignSliceFailure(state, action) {
        state.isLoading = false;
        state.message = action.payload;
      },
      yearlyCampaignSliceReset(state) {
        state.isLoading = false;
        state.message = null;
        state.data = null;
        state.error = "";
      },
  },
});

export const yearlyCampaignHandler = () => async (dispatch: any) => {
  try {
    dispatch(yearlyCampaignsAction.yearlyCampaignSlice());
    const response: any = await yearlyCampaign();
    dispatch(yearlyCampaignsAction.yearlyCampaignSliceSuccess(response));
  } catch (e: any) {
    dispatch(yearlyCampaignsAction.yearlyCampaignSliceFailure(e?.response?.data?.message));
    dispatch(yearlyCampaignsAction.yearlyCampaignSliceReset());
  }
};
export default yearlyCampaignSlice.reducer;
export const yearlyCampaignsAction = yearlyCampaignSlice.actions;
